import { defineComponent } from 'vue';
import { currentAccount, loginHref } from '@/client/utils/account';
import { paths } from '@/common/app/paths';
import { translateText } from '@/client/directives/i18n';
/** A small corner tag on game pages: the logged-in nickname, or a hint to log in (which then adds this game). */
export default defineComponent({
    name: 'AccountTag',
    data() {
        return {
            nickname: currentAccount()?.nickname,
        };
    },
    computed: {
        loginHref() {
            return loginHref();
        },
        myGamesHref() {
            return paths.MY_GAMES;
        },
        myGamesTitle() {
            return translateText('My games');
        },
    },
});
